import api from "../base-url";

async function updateAppRequest(
  id: number,
  name: string,
  description: string,
  icon: string
) {
  let payload = { name: name, description: description, icon: icon };
  let res = await api.patch(`/apps/${id}`, payload);
  
  return res.status;
}

export default updateAppRequest;
